import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface WalletPropertiesStore {
  walletNames: { [key: string]: string }
  walletEmojis: { [key: string]: string }
  walletEthAddresses: { [key: string]: string }
  walletBTCMinterAddresses: { [key: string]: string }
  walletSolAddresses: { [key: string]: string }
  setWalletName: (walletId: string, name: string) => void
  setWalletEmoji: (walletId: string, emoji: string) => void
  setWalletEthAddress: (walletId: string, address: string) => void
  setWalletBTCMinterAddress: (walletId: string, address: string) => void
  setWalletSolAddress: (walletId: string, address: string) => void
}

export const createWalletPropertiesStore = (storage: StateStorage) =>
  createStore<WalletPropertiesStore>(
    storage,
    (set, get) => ({
      walletNames: {},
      walletEmojis: {},
      walletEthAddresses: {},
      walletBTCMinterAddresses: {},
      walletSolAddresses: {},
      setWalletName: (walletId, name) => {
        const names = get().walletNames
        set({ walletNames: { ...names, [walletId]: name } })
      },
      setWalletEmoji: (walletId, emoji) => {
        const emojis = get().walletEmojis
        set({ walletEmojis: { ...emojis, [walletId]: emoji } })
      },
      setWalletEthAddress: (walletId, address) => {
        const ethAddresses = get().walletEthAddresses
        set({ walletEthAddresses: { ...ethAddresses, [walletId]: address } })
      },
      setWalletBTCMinterAddress: (walletId, address) => {
        const btcAddresses = get().walletBTCMinterAddresses
        set({
          walletBTCMinterAddresses: { ...btcAddresses, [walletId]: address },
        })
      },
      setWalletSolAddress: (walletId, address) => {
        const solAddresses = get().walletSolAddresses
        set({ walletSolAddresses: { ...solAddresses, [walletId]: address } })
      },
    }),
    {
      persist: {
        name: 'walletProperties',
        version: 0,
      },
    }
  )
